import { render, staticRenderFns } from "./ContactListItemSkeleton.vue?vue&type=template&id=359f1015&scoped=true&"
import script from "./ContactListItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ContactListItemSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f1015",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
